module.exports = __webpack_public_path__ + "static/media/trip-image-2.25352d19.png";